import { memo } from 'react';

const NoData = () => {
  return <div>No data available</div>;
};

export default memo(NoData);
